import type { CSSProperties } from 'react';

import { DocsSidebarBody } from 'components/docs/docs-sidebar-body';

const DocsSidebar = ({ topOffset = 64 }: { topOffset?: number }) => (
	<aside
		className='custom-scrollbar sticky hidden h-[calc(100dvh-var(--docs-header-offset))] overflow-y-auto border-r bg-canvas px-3 py-6 md:block'
		style={{ '--docs-header-offset': `${topOffset}px`, top: topOffset } as CSSProperties}>
		<DocsSidebarBody />
	</aside>
);

export { DocsSidebar };
